/* eslint-disable indent */
/* eslint-disable react/prop-types */

import React from "react";
import Select from "react-select";
import Button from "../../../component/button/Button";
import SelectInput from "../../../component/input/SelectInput";
import TextArea from "../../../component/input/TextArea";
import TextInput from "../../../component/input/TextInput";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import { emailUserOptions } from "./QueryStaticData";

function AddComments({
  commentScreenshots,
  handleInitialState,
  getCommentImagesUrl,
  handleResponseSubmit,
  commentLoading,
  commentInput,
  commentScreenshotsLoading,
  onEmailChangesHandle,
  selectedEmail
}) {
  return (
    <form className="pl-1 pr-1" onSubmit={handleResponseSubmit}>
      <div className="row">
        <div className="col-md-12 col-xl-12 col-lg-12">
          <TextArea
            type="text"
            row={8}
            required={false}
            textWhite={false}
            name="commentBody"
            htmlFor="commentBody"
            label="Write a comment"
            onChange={handleInitialState}
            value={commentInput.commentBody}
            placeholder="Enter your comment"
          />
        </div>
        <div className="col-md-12 col-xl-12 col-lg-12">
          <div className="mb-1">
            <label>
              Select Multiple Mail You want to send
              <span className="text-danger">*</span>
            </label>
            <Select
              isMulti
              name="categories"
              classNamePrefix="select"
              options={emailUserOptions}
              defaultValue={selectedEmail}
              className="basic-multi-select"
              onChange={onEmailChangesHandle}
            />
          </div>
        </div>
        <div className="col-md-12 col-xl-12 col-lg-12">
          <SelectInput
            name="commentStatus"
            required={false}
            textWhite={false}
            isLabeled={false}
            label="Select Status"
            onChange={handleInitialState}
            value={commentInput.commentStatus}
          >
            <option value=""> Select Status</option>
            <option value="SOLVED">SOLVED</option>
            <option value="UN-SOLVED">UN-SOLVED</option>
            <option value="IN-PROGRESS">IN-PROGRESS</option>
          </SelectInput>
        </div>
        <div className="col-md-12 col-xl-12 col-lg-12">
          <div className="mb-1">
            <TextInput
              type="date"
              required={false}
              textWhite={false}
              label="Select Date"
              name="querySolveDate"
              htmlFor="querySolveDate"
              placeholder="Select Date"
              onChange={handleInitialState}
              value={commentInput.querySolveDate}
            />
          </div>
        </div>

        <div className="col-md-12 col-xl-12 col-lg-12">
          <div className="mb-1">
            <HeaderTag
              type="h4"
              title="Add photos of your comment"
              isClassName={false}
            />
            <TextInput
              multiple
              type="file"
              file={true}
              required={false}
              textWhite={false}
              htmlFor="commentImages"
              label="Add photos here"
              onChange={getCommentImagesUrl}
            />
          </div>
        </div>

        <div className="col-md-12 col-xl-12 col-lg-12 mb-3">
          {commentScreenshots.map(
            (commentScreenshot, commentScreenShotIndex) => (
              <img
                src={commentScreenshot}
                className="img-thumbnail mr-2"
                style={{
                  height: "80px",
                  width: "80px"
                }}
                key={commentScreenShotIndex}
              />
            )
          )}
        </div>
        <div className="col-md-12 col-xl-12 col-lg-12">
          {commentLoading ? (
            <SpinnerButton />
          ) : commentScreenshotsLoading ? (
            <Button
              disabled
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn text-white btn-block btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );
}

export default AddComments;
